import rhinoSession from 'rhino/src/components/session/session.module';
import * as rnAdmin from './admin.service';

export default angular.module('rhino.components.admin', [rhinoSession])
  .factory(rnAdmin.name, rnAdmin.default)
  .name;




// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/admin/admin.module.js